import {
  ConnectedEmpireNavigation,
  Selectors,
  openURL,
  useIsDesktop,
  useWidgetState,
} from '@eCommerce/frontend-legacy-shared-library-native';
import React from 'react';

import ConnectedMyRewardsDesktopHeader from 'containers/MyRewardsDesktopHeader';

import NavigationDrawer from '../NavigationDrawer';

interface HeaderProps {
  expanded: boolean;
}

const Header: React.FC<HeaderProps> = ({expanded}: HeaderProps) => {
  const isDesktop = useIsDesktop();
  const isLoggedIn = useWidgetState(Selectors.isLoggedInSelector) as boolean;
  const loginHref = '/myrewards/profile/signin/';

  const handleLogin = () => {
    openURL(loginHref);
  };

  return isDesktop ? (
    <>
      <ConnectedEmpireNavigation
        onLogin={handleLogin}
        isExpanded={expanded}
        isLoggedIn={isLoggedIn}
        loginLinkHref={loginHref}
      />
      <ConnectedMyRewardsDesktopHeader />
    </>
  ) : (
    <NavigationDrawer />
  );
};

export default Header;
